var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDelete2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1715889770946,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 7230,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M655.36 368.853333a32 32 0 0 1 0 45.248l-98.090667 98.005334L655.36 610.133333a32 32 0 0 1-45.226667 45.269334L512 557.333333l-98.133333 98.048a32 32 0 1 1-45.226667-45.269333l98.090667-98.005333-98.090667-98.005334a32 32 0 0 1 45.226667-45.269333l98.133333 98.048 98.133333-98.048a32 32 0 0 1 45.226667 0z",
    fill: "#C20E4D",
    "p-id": 7231
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M138.666667 512c0-206.186667 167.146667-373.333333 373.333333-373.333333S885.333333 305.813333 885.333333 512 718.186667 885.333333 512 885.333333 138.666667 718.186667 138.666667 512zM512 202.666667C341.162667 202.666667 202.666667 341.162667 202.666667 512S341.162667 821.333333 512 821.333333 821.333333 682.837333 821.333333 512 682.837333 202.666667 512 202.666667z",
    fill: "#C20E4D",
    "p-id": 7232
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDelete2);
export default __webpack_public_path__ + "static/media/icon-delete-2.9701b78ff62d01c1608b0d72670c7b12.svg";
export { ForwardRef as ReactComponent };